import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";

import bgImage from "assets/images/SpechsSupplies/world-map.png";

function Hero() {
  return (
    <MKBox
      sx={{
        position: "relative",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <MKBox sx={{ position: "absolute", inset: 0, backgroundColor: "rgba(0,0,0,0.7)" }} />

      <Container sx={{ position: "relative", zIndex: 1, pt: "64px", pb: { xs: 4, md: 0 } }}>
        <Grid container spacing={6} alignItems="center">
          {/* Left: text + CTAs */}
          <Grid item xs={12} md={6}>
            <MKTypography
              variant="caption"
              sx={{
                color: "rgba(255,255,255,0.65)",
                fontWeight: 600,
                letterSpacing: "0.1em",
                textTransform: "uppercase",
                display: "block",
                mb: 2,
              }}
            >
              Delivered to your facility across Europe and Asia
            </MKTypography>

            <MKTypography
              variant="h1"
              color="white"
              fontWeight="bold"
              sx={{ fontSize: { xs: "2.2rem", md: "3rem" }, lineHeight: 1.15, mb: 3 }}
            >
              Facilities Supplies,
              <br />
              <MKTypography
                component="span"
                variant="inherit"
                sx={{ opacity: 0.5, color: "white !important" }}
              >
                Delivered.
              </MKTypography>
            </MKTypography>

            <MKTypography
              variant="body1"
              color="white"
              sx={{ opacity: 0.75, mb: 5, lineHeight: 1.8 }}
            >
              Cleaning chemicals, hygiene products, PPE, janitorial equipment, and washroom
              essentials — supplied in business quantities to offices, schools, and facilities
              across Europe and Asia.
            </MKTypography>

            <MKButton
              variant="contained"
              size="large"
              onClick={() => window.dispatchEvent(new Event("open-supplies-form"))}
              sx={{
                background: "#ff9f1c",
                color: "white",
                boxShadow: "none",
                fontWeight: 700,
                "&:hover": { background: "#e07000", boxShadow: "none" },
              }}
            >
              Request a Quote
            </MKButton>
          </Grid>

          {/* Right: stat cards */}
          <Grid item xs={12} md={6}>
            <MKBox
              sx={{
                display: "grid",
                gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
                gap: 2,
                px: { xs: 1, sm: 0 },
              }}
            >
              {[
                {
                  icon: "science",
                  label: "Cleaning Chemicals",
                  sub: "Professional-grade formulas",
                },
                {
                  icon: "sanitizer",
                  label: "Hygiene & Disposables",
                  sub: "Paper, soap, wipes & more",
                },
                {
                  icon: "cleaning_services",
                  label: "Janitorial Equipment",
                  sub: "Mops, machines & tools",
                },
                { icon: "back_hand", label: "PPE", sub: "EU-compliant protective gear" },
                { icon: "wash", label: "Washroom Supplies", sub: "Dispensers & consumables" },
                { icon: "delete", label: "Bin Liners & Waste", sub: "All waste stream types" },
              ].map(({ icon, label, sub }) => (
                <MKBox
                  key={label}
                  sx={{
                    background: "rgba(255,255,255,0.08)",
                    backdropFilter: "blur(12px)",
                    border: "1px solid rgba(255,255,255,0.15)",
                    borderRadius: 2,
                    p: 2,
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Icon sx={{ color: "#ff9f1c", fontSize: "22px !important", mb: 0.75 }}>
                    {icon}
                  </Icon>
                  <MKTypography
                    variant="body2"
                    fontWeight="bold"
                    sx={{ color: "white !important", lineHeight: 1.3, mb: 0.25 }}
                  >
                    {label}
                  </MKTypography>
                  <MKTypography variant="caption" sx={{ color: "rgba(255,255,255,0.5)" }}>
                    {sub}
                  </MKTypography>
                </MKBox>
              ))}
            </MKBox>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Hero;
